<div class="detail-row">
    <span class="detail-label">{{ label }}:</span>
    @if (isMissing) {
        <span class="detail-value missing">Missing</span>
    } @else {
        <span class="detail-value" [ngClass]="valueClass">
            @if (capitalCase && upperCase) {
                {{ value | capitalCase | uppercase }}
            } @else if (capitalCase) {
                {{ value | capitalCase }}
            } @else if (upperCase) {
                {{ value | uppercase }}
            } @else {
                {{ value }}
            }
        </span>
    }
</div>
